exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".LineTitle[data-v-04e3a4e2]{line-height:1rem;font-size:16px;text-align:left;padding:.1rem;padding-left:.3rem;padding-right:.3rem;font-weight:700;background-color:#59b2df;color:#fff}.priceTitle[data-v-04e3a4e2]{font-size:12px;font-weight:600}.priceList[data-v-04e3a4e2]{margin-top:.2rem;margin-bottom:.2rem;background-color:#fff;padding:.1rem}.priceDetail[data-v-04e3a4e2]{background-color:#f2f2f2;margin-top:.2rem;padding:.2rem;border-radius:.3rem}.btnDiv[data-v-04e3a4e2]{text-align:left;padding-left:.3rem;margin-top:.1rem}.dialogEdit[data-v-04e3a4e2]{padding:.1rem;margin-top:.2rem}", ""]);

// exports
